<script lang="ts" setup>
import { watch } from 'vue'
import { useUserStore } from '@/stores'
import {
  PaymentMethodSelector,
  createShowPaymentMethodSelector,
  useFixedBottomPayment,
  usePurchase,
} from '@/composables/payment'

defineProps<{
  config: any
}>()

const user = useUserStore()
const {
  templateProducts,
  PayTemplate,
  currentPaymentMethod,
  availablePaymentMethods,
  selectPaymentMethod,
} = usePurchase('store')

// 是否显示支付方式选择器
const showPaymentMethodSelector = createShowPaymentMethodSelector(availablePaymentMethods)

// 判断是否需要固定在底部
const { isFixedBottom, containerRef, checkContentHeight } = useFixedBottomPayment()

// 监听支付方式切换，重新计算高度
watch(currentPaymentMethod, () => {
  checkContentHeight()
})
</script>

<template>
  <div ref="containerRef" class="pay-page">
    <BasicNavbar class="color-n-text-2" />

    <!-- Balance -->
    <div class="mt-44px px-16px">
      <p class="flex items-center space-x-5px">
        <span class="text-18px text-n-primary font-500">{{ user.$state.coinBalance }}</span>
        <span class="text-14px font-400" style="color: #6A6E7A;">{{ config.texts.coins }}</span>
      </p>
    </div>

    <!-- Products Grid -->
    <div class="pay-grid mt-16px px-16px">
      <div
        v-for="(item) in templateProducts"
        :key="item.productId"
        class="pay-item"
        @click="PayTemplate(item)"
      >
        <!-- Popular Tag -->
        <div v-if="item.marketingText" class="popular-tag">
          {{ item.marketingText }}
        </div>

        <!-- Top Section -->
        <div class="pay-item-top">
          <div class="flex items-center justify-center space-x-4px">
            <img class="w-24px h-24px" :src="config.resources.goldCoinIcon">
            <span class="coin-amount">{{ item.coinsBuy }}</span>
          </div>
          <div class="flex items-center justify-center mt-6px space-x-4px">
            <span class="bonus-text">+{{ item.coinsBonus }}{{ config.texts.coins }}</span>
            <span v-if="item.cornerTip" class="bonus-tag">+{{ parseFloat((item.coinsBonus / item.coinsBuy * 100).toFixed(0)) }}%</span>
          </div>
        </div>

        <!-- Bottom Section (Price) -->
        <div class="pay-item-bottom">
          <span class="price-text">$ {{ item.price }}</span>
        </div>
      </div>
    </div>

    <!-- Payment Method Selector - 动态位置 -->
    <div
      v-if="showPaymentMethodSelector"
      class="flex justify-center"
      :class="[
        isFixedBottom ? 'fixed bottom-0px left-0 right-0 z-50' : 'mt-16px px-16px',
      ]"
    >
      <PaymentMethodSelector
        variant="large"
        :model-value="currentPaymentMethod"
        :available-methods="availablePaymentMethods"
        @update:model-value="selectPaymentMethod"
      />
    </div>

    <!-- Tips -->
    <div :class="`mt-24px px-16px text-10px text-n-text-3 ${isFixedBottom ? 'pb-80px' : 'pb-20px'}`">
      <p class="text-12px mt-6px">
        {{ config.texts.tips }}
      </p>
      <p class="mt-6px">
        {{ config.texts.tip1 }}
      </p>
      <p class="mt-6px">
        {{ config.texts.tip2 }}
      </p>
      <p class="mt-6px">
        {{ config.texts.tip3 }}
      </p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.pay-page {
  min-height: 100vh;
  background: #fff;
}

.pay-grid {
  display: grid;
  grid-template-columns: repeat(2, 168px);
  gap: 12px;
  justify-content: center;
}

.pay-item {
  position: relative;
  width: 168px;
  height: 110px;
  background: #FFF4EC;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  overflow: hidden;
  cursor: pointer;
}

.pay-item-top {
  height: 74px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.pay-item-bottom {
  height: 36px;
  background: #FFE7D3;
  display: flex;
  justify-content: center;
  align-items: center;
}

.coin-amount {
  font-weight: 500;
  font-size: 18px;
  color: #633329;
}

.bonus-text {
  font-weight: 500;
  font-size: 12px;
  color: #A56E4A;
  line-height: 12px;
}

.bonus-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 36px;
  height: 18px;
  padding: 0 6px;
  border-radius: 10px;
  border: 1px solid #A56E4A;
  font-weight: 500;
  font-size: 10px;
  color: #A56E4A;
  line-height: 10px;
}

.price-text {
  font-weight: 500;
  font-size: 16px;
  color: #FF771C;
  line-height: 12px;
}

.popular-tag {
  position: absolute;
  top: 0;
  left: 0;
  height: 16px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  background: linear-gradient(90deg, #FF4754 0%, #FEA94C 100%);
  border-radius: 8px 100px 100px 0;
  font-weight: 500;
  font-size: 10px;
  color: #fff;
}
</style>
